import store from '@/store'
import axios from 'axios'
import { Toast } from 'vant'

// 创建axios实例
const instance = axios.create({
  baseURL: 'https://data.isbn.work/',
  // baseURL: 'http://127.0.0.1:6066/',
  timeout: 1800000
})

// 添加请求拦截器
instance.interceptors.request.use(function (config) {
  // 在发送请求之前做些什么
  // 请求拦截器中，每次请求打开loading，禁止背景点击
  Toast.loading({
    message: '加载中...',
    forbidClick: true, // 禁止背景点击
    duration: 0, // 时长，不会自动消失
    loadingType: 'spinner' // 图标
  })

  // 只要有token，就在请求时携带，放在请求头中
  const token = store.getters.token
  if (token) {
    config.headers.Authorization = 'Bearer ' + token
  }
  return config
}, function (error) {
  // 对请求错误做些什么
  return Promise.reject(error)
})

// 添加响应拦截器
instance.interceptors.response.use(function (response) {
  // 检查是否是文件下载
  const contentType = response.headers['content-type']
  if (contentType && contentType.includes('application/octet-stream')) {
    // 这是文件下载响应，直接返回
    Toast.clear()
    return response
  }

  // 2xx 范围内的状态码都会触发该函数。
  // 对响应数据做点什么
  // 响应拦截器，每次响应关闭loading
  const code = response.data.code
  if (code === 0) {
    Toast.clear()
    return response.data
  }

  if (code === 1 && response.data.data === 401) {
    store.commit('removeUserInfo')
    // 去登录页
    window.location.href = '/'
    Toast.fail('登录已过期，请点击重新登录')
    return
  }

  // 1.提示，this.$toast() 只能在组件中使用, Toast 采用单例模式，会覆盖前面的效果
  Toast.fail(response.data.msg || '系统错误,请至首页联系管理员微信')
  // 2.抛出一个错误的promise
  return Promise.reject(response.data.msg)
}, function (error) {
  // 超出 2xx 范围的状态码都会触发该函数。
  // 对响应错误做点什么
  Toast.fail(error.response.data.msg)
  return Promise.reject(error)
})

// 导出
export default instance
